// project modules
import { getBaseUrl, sendRequest } from '../helpers/apiHelper';

export const getList = async (searchQuery?: string, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Customers?${searchQuery ? 'searchQuery=' + searchQuery : ''}`, 'get', null, null, abortSignal);
};

export const getById = async (id: string, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Customers/${id}`, 'get', null, null, abortSignal);
};

